import { Alert } from '@ksyos/design-system';
import { translateKey } from '../../../translate';
import { Button, FormParagraph, ListHeader, OrderedList } from '../../elements/common';
import { ListItem } from '../../elements/List/List';
import { Modal } from '../../elements/modals/Modal';

interface IKsyosUrlNotSupportedModalProps {
    isOpen: boolean;
    onClose: () => Promise<void>;
}

export function KsyosUrlNotSupportedModal(props: IKsyosUrlNotSupportedModalProps) {
    return (
        <Modal
            actionButtons={[
                <Button
                    color="secondary"
                    large
                    onClick={props.onClose}
                    right
                >
                    {translateKey('common.closeShort')}
                </Button>,
            ]}
            isOpen={props.isOpen}
            onClose={props.onClose}
            size="large"
            title="Bestand uitlezen lukt niet"
        >
            <>
                <Alert
                    appearance="warning"
                    hasIcon={true}
                    noMargin={true}
                >
                    Bestanden kunnen tijdelijk niet met Internet Explorer 11 worden uitgelezen
                </Alert>
                <FormParagraph>
                    Ksyos is op de hoogte van de storing. Er wordt door ons hard gewerkt aan een oplossing. In de
                    tussentijd is er een andere manier waarop de recorder uitgelezen kan worden. Sorry voor het ongemak,
                    we verwachten dat het niet lang zal duren.
                </FormParagraph>
                <ListHeader className="mb-1">Hoe kan je nu snel verder?</ListHeader>
                <OrderedList>
                    <ListItem>Open een andere browser, bijvoorbeeld Chrome of Firefox.</ListItem>
                    <ListItem>Ga naar ksyos.nl, klik op Log in, rechts bovenin het scherm.</ListItem>
                    <ListItem>Log in met je gebruikersnaam en wachtwoord (en kies eventueel Cardiologie).</ListItem>
                    <ListItem>Klik op Recorders in het menu en lees de recorder uit.</ListItem>
                </OrderedList>
            </>
        </Modal>
    );
}
